export { default } from './InitColorSchemeScript';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/InitColorSchemeScript/index.js
// module id = 1786
// module chunks = 25